export const environment = {
  production: false,

  // the successful login return url
  authRedirectURI: 'https://portfoliostaging.reconcept.nl/login/success/',
  canChangeBE: true,
};
